
import { Snackbar, IconButton, Box } from '@mui/material';
import Alert from '@mui/material/Alert';
import CloseIcon from '@mui/icons-material/Close';

function ErrorPopup({ open, message, onClose }: any) {
  return (
    <Snackbar
      open={open}
      autoHideDuration={6000}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert
        onClose={onClose}
        severity='error'
        variant='filled'
        action={
          <IconButton
            aria-label='close'
            color='inherit'
            size='small'
            onClick={onClose}
          >
            <CloseIcon fontSize='inherit' />
          </IconButton>
        }
        sx={{ width: '100%' }}
      >
        <Box sx={{whiteSpace:'pre-line'}}>
          {message}
        </Box>
      </Alert>
    </Snackbar>
  );
}

export default ErrorPopup;
